import { AbstractFilterHandlerResultModel } from '../models/abstract-filter-handler-result-model'
import { FilterHandlerContext } from '../models/filter-handler-context'
import { FundCategoryModel } from '../models/fund-category-model'
import { FundGroupBaseFilterHandlerResultModel } from '../models/fund-group-base-filter-handler-result-model'
import { FundRuleName } from './fund-rule-name'
import { IFilterHandler } from './ifilter-handler'

export class RuleBaseFundRetrievalCommonFilterHandler
  implements IFilterHandler
{
  handleFilterSelection(
    filterName: FundRuleName,
    handlerContext: FilterHandlerContext,
  ): AbstractFilterHandlerResultModel {
    const fundCategoryModel: FundCategoryModel =
      handlerContext.getFundCollection(filterName)
    return new FundGroupBaseFilterHandlerResultModel([fundCategoryModel])
  }
}
